module.exports = __webpack_public_path__ + "static/media/landing-feature-validation.59309301.svg";